<template>
	<section class="section more-employers" v-if="results">
		<div class="container mx-auto flex flex-wrap items-center">

			<!-- <div class="section-title__wrapper pl-4">
				<h3 class="section-title">More Employers</h3>
			</div>
			<div class="section-btn__wrapper px-4">
				<a class="btn btn-medium btn-rounded border-2 border-blue-dark" href="/search/organisations" aria-label="View all">View all</a>
			</div> -->

      <div class="section-title__wrapper pl-4">
				<h3 class="section-title">More Employers</h3>
			</div>
			<div class="section-btn__wrapper px-4">
				<a class="btn btn-medium border-2 border-blue-dark btn-rounded" href="/search/organisations" aria-label="View all">View all</a>
			</div>

			<div class="org-cards">
				<template v-for="(organisation, o) in results" :key="o">
					<block-org-card :payload="organisation"></block-org-card>
				</template>
			</div>
		</div>
	</section>
</template>

<script>
	// THIS COMPONENT HAS BEEN SUPERCEEDED BY "ORGANISATIONSTOFOLLOW" BLOCK.

	import algoliasearch from 'algoliasearch';

	export default {
    props: {
			hits: {
				type: Number,
				default: 3
			}
		},

		data() {
			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'orgs-2023-test' : 'orgs-2023-live',
				searchObject: {
					hitsPerPage: this.hits,
					facets: ["featured"],
					facetFilters: [["featured:true"]]
				},
				results: false
			}
		},

		methods: {
			calculated_img(item,index) {
				if (item.image !== "") {
					return 'background-image: url('+item.image+');';
				}
				return 'background-image: url(/images/collections/collection-bg-'+(index+1)+'.jpg?'+this.$config.version+');';
			}
		},

		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);


			this.index
				.search('', this.searchObject)
				.then((results) => {
					//console.log("we got initial hits:",results.hits,results.nbHits);
					console.log("featured employers search raw results:", results);
					if (results.nbHits > 0) {
						this.results = results.hits;
					} else {
						this.results = false;
					}
				});
		}
	}
</script>
